import {Component, HostBinding, OnInit} from '@angular/core';
import {ErrorLoggerService} from '@services/error-logger.service';

@Component({
    selector: 'app-not-found',
    template: `
        <h1>Страница не найдена</h1>

        <p>Страница, которую вы запрашиваете, пропала. Наши специалисты уже приступили к её поискам. </p>

        <br>

        <h2>Почему так вышло?</h2>
        <ul>
            <li>&bull; Адрес страницы введён с опечатками</li>
            <li>&bull; Страницы с запрошенным адресом никогда не было</li>
            <li>&bull; Такой страницы больше нет или у неё изменился адрес</li>
        </ul>

        <br>

        <h2>Что можно сделать?</h2>
        <ul>
            <li>&bull; <a href="/">Перейти на главную</a></li>
            <li>&bull; <a href="https://lab365.freshdesk.com/support/tickets/new" target="_blank">Написать в поддержку</a></li>
        </ul>
    `
})
export class NotFoundComponent implements OnInit {
    constructor(
        private logger: ErrorLoggerService,
    ) {
    }

    ngOnInit(): void {
        this.logger.log(null, `Catched «NotFoundPage». See Location section for URL`);
    }
}
